export const LOCATION_RECORDS_PER_PAGE = 20;

export const locationsParams = {
  // _dc: getCurrentEpochTime().milliseconds,
  //   referrer: "pms",
  response: "detailed",
  active: 1,
  // keyword: checkValueNotNull(filters?.keyword) ? filters?.keyword : "",
  all: 1,
  page: 1,
  start: 0,
  limit: LOCATION_RECORDS_PER_PAGE,
};

export const providersParams = {
  //   _dc: getCurrentEpochTime().milliseconds,
  //   referrer: "pms",
  all: 0,
  page: 1,
  start: 0,
  limit: 1000,
};

export const location_types = [
  {
    id: "all",
    label: "All",
  },
  {
    id: "1",
    label: "Active",
  },
  {
    id: "0",
    label: "Inactive",
  },
];

export const location_states = [
  { id: "AL", label: "AL", value: "Alabama" },
  { id: "AK", label: "AK", value: "Alaska" },
  { id: "AZ", label: "AZ", value: "Arizona" },
  { id: "AR", label: "AR", value: "Arkansas" },
  { id: "CA", label: "CA", value: "California" },
  { id: "CO", label: "CO", value: "Colorado" },
  { id: "CT", label: "CT", value: "Connecticut" },
  { id: "DE", label: "DE", value: "Delaware" },
  { id: "FL", label: "FL", value: "Florida" },
  { id: "GA", label: "GA", value: "Georgia" },
  { id: "HI", label: "HI", value: "Hawaii" },
  { id: "ID", label: "ID", value: "Idaho" },
  { id: "IL", label: "IL", value: "Illinois" },
  { id: "IN", label: "IN", value: "Indiana" },
  { id: "IA", label: "IA", value: "Iowa" },
  { id: "KS", label: "KS", value: "Kansas" },
  { id: "KY", label: "KY", value: "Kentucky" },
  { id: "LA", label: "LA", value: "Louisiana" },
  { id: "ME", label: "ME", value: "Maine" },
  { id: "MD", label: "MD", value: "Maryland" },
  { id: "MA", label: "MA", value: "Massachusetts" },
  { id: "MI", label: "MI", value: "Michigan" },
  { id: "MN", label: "MN", value: "Minnesota" },
  { id: "MS", label: "MS", value: "Mississippi" },
  { id: "MO", label: "MO", value: "Missouri" },
  { id: "MT", label: "MT", value: "Montana" },
  { id: "NE", label: "NE", value: "Nebraska" },
  { id: "NV", label: "NV", value: "Nevada" },
  { id: "NH", label: "NH", value: "New Hampshire" },
  { id: "NJ", label: "NJ", value: "New Jersey" },
  { id: "NM", label: "NM", value: "New Mexico" },
  { id: "NY", label: "NY", value: "New York" },
  { id: "NC", label: "NC", value: "North Carolina" },
  { id: "ND", label: "ND", value: "North Dakota" },
  { id: "OH", label: "OH", value: "Ohio" },
  { id: "OK", label: "OK", value: "Oklahoma" },
  { id: "OR", label: "OR", value: "Oregon" },
  { id: "PA", label: "PA", value: "Pennsylvania" },
  { id: "RI", label: "RI", value: "Rhode Island" },
  { id: "SC", label: "SC", value: "South Carolina" },
  { id: "SD", label: "SD", value: "South Dakota" },
  { id: "TN", label: "TN", value: "Tennessee" },
  { id: "TX", label: "TX", value: "Texas" },
  { id: "UT", label: "UT", value: "Utah" },
  { id: "VT", label: "VT", value: "Vermont" },
  { id: "VA", label: "VA", value: "Virginia" },
  { id: "WA", label: "WA", value: "Washington" },
  { id: "WV", label: "WV", value: "West Virginia" },
  { id: "WI", label: "WI", value: "Wisconsin" },
  { id: "WY", label: "WY", value: "Wyoming" },
];

export const send_note_methods = [
  { id: "email", label: "Email" },
  { id: "efax", label: "eFax" },
  { id: "both", label: "Both" },
  { id: "chat", label: "Chat" },
];

export const time_slots = [
  { label: "12:00 AM", id: "12:00 AM" },
  { label: "12:15 AM", id: "12:15 AM" },
  { label: "12:30 AM", id: "12:30 AM" },
  { label: "12:45 AM", id: "12:45 AM" },
  { label: "01:00 AM", id: "01:00 AM" },
  { label: "01:15 AM", id: "01:15 AM" },
  { label: "01:30 AM", id: "01:30 AM" },
  { label: "01:45 AM", id: "01:45 AM" },
  { label: "02:00 AM", id: "02:00 AM" },
  { label: "02:15 AM", id: "02:15 AM" },
  { label: "02:30 AM", id: "02:30 AM" },
  { label: "02:45 AM", id: "02:45 AM" },
  { label: "03:00 AM", id: "03:00 AM" },
  { label: "03:15 AM", id: "03:15 AM" },
  { label: "03:30 AM", id: "03:30 AM" },
  { label: "03:45 AM", id: "03:45 AM" },
  { label: "04:00 AM", id: "04:00 AM" },
  { label: "04:15 AM", id: "04:15 AM" },
  { label: "04:30 AM", id: "04:30 AM" },
  { label: "04:45 AM", id: "04:45 AM" },
  { label: "05:00 AM", id: "05:00 AM" },
  { label: "05:15 AM", id: "05:15 AM" },
  { label: "05:30 AM", id: "05:30 AM" },
  { label: "05:45 AM", id: "05:45 AM" },
  { label: "06:00 AM", id: "06:00 AM" },
  { label: "06:15 AM", id: "06:15 AM" },
  { label: "06:30 AM", id: "06:30 AM" },
  { label: "06:45 AM", id: "06:45 AM" },
  { label: "07:00 AM", id: "07:00 AM" },
  { label: "07:15 AM", id: "07:15 AM" },
  { label: "07:30 AM", id: "07:30 AM" },
  { label: "07:45 AM", id: "07:45 AM" },
  { label: "08:00 AM", id: "08:00 AM" },
  { label: "08:15 AM", id: "08:15 AM" },
  { label: "08:30 AM", id: "08:30 AM" },
  { label: "08:45 AM", id: "08:45 AM" },
  { label: "09:00 AM", id: "09:00 AM" },
  { label: "09:15 AM", id: "09:15 AM" },
  { label: "09:30 AM", id: "09:30 AM" },
  { label: "09:45 AM", id: "09:45 AM" },
  { label: "10:00 AM", id: "10:00 AM" },
  { label: "10:15 AM", id: "10:15 AM" },
  { label: "10:30 AM", id: "10:30 AM" },
  { label: "10:45 AM", id: "10:45 AM" },
  { label: "11:00 AM", id: "11:00 AM" },
  { label: "11:15 AM", id: "11:15 AM" },
  { label: "11:30 AM", id: "11:30 AM" },
  { label: "11:45 AM", id: "11:45 AM" },
  { label: "12:00 PM", id: "12:00 PM" },
  { label: "12:15 PM", id: "12:15 PM" },
  { label: "12:30 PM", id: "12:30 PM" },
  { label: "12:45 PM", id: "12:45 PM" },
  { label: "01:00 PM", id: "01:00 PM" },
  { label: "01:15 PM", id: "01:15 PM" },
  { label: "01:30 PM", id: "01:30 PM" },
  { label: "01:45 PM", id: "01:45 PM" },
  { label: "02:00 PM", id: "02:00 PM" },
  { label: "02:15 PM", id: "02:15 PM" },
  { label: "02:30 PM", id: "02:30 PM" },
  { label: "02:45 PM", id: "02:45 PM" },
  { label: "03:00 PM", id: "03:00 PM" },
  { label: "03:15 PM", id: "03:15 PM" },
  { label: "03:30 PM", id: "03:30 PM" },
  { label: "03:45 PM", id: "03:45 PM" },
  { label: "04:00 PM", id: "04:00 PM" },
  { label: "04:15 PM", id: "04:15 PM" },
  { label: "04:30 PM", id: "04:30 PM" },
  { label: "04:45 PM", id: "04:45 PM" },
  { label: "05:00 PM", id: "05:00 PM" },
  { label: "05:15 PM", id: "05:15 PM" },
  { label: "05:30 PM", id: "05:30 PM" },
  { label: "05:45 PM", id: "05:45 PM" },
  { label: "06:00 PM", id: "06:00 PM" },
  { label: "06:15 PM", id: "06:15 PM" },
  { label: "06:30 PM", id: "06:30 PM" },
  { label: "06:45 PM", id: "06:45 PM" },
  { label: "07:00 PM", id: "07:00 PM" },
  { label: "07:15 PM", id: "07:15 PM" },
  { label: "07:30 PM", id: "07:30 PM" },
  { label: "07:45 PM", id: "07:45 PM" },
  { label: "08:00 PM", id: "08:00 PM" },
  { label: "08:15 PM", id: "08:15 PM" },
  { label: "08:30 PM", id: "08:30 PM" },
  { label: "08:45 PM", id: "08:45 PM" },
  { label: "09:00 PM", id: "09:00 PM" },
  { label: "09:15 PM", id: "09:15 PM" },
  { label: "09:30 PM", id: "09:30 PM" },
  { label: "09:45 PM", id: "09:45 PM" },
  { label: "10:00 PM", id: "10:00 PM" },
  { label: "10:15 PM", id: "10:15 PM" },
  { label: "10:30 PM", id: "10:30 PM" },
  { label: "10:45 PM", id: "10:45 PM" },
  { label: "11:00 PM", id: "11:00 PM" },
  { label: "11:15 PM", id: "11:15 PM" },
  { label: "11:30 PM", id: "11:30 PM" },
  { label: "11:45 PM", id: "11:45 PM" },
  { label: "12:00 AM", id: "12:00 AM" },
];

export const time_slots_24_hours = [
  { label: "00:00", id: "00:00" },
  { label: "00:15", id: "00:15" },
  { label: "00:30", id: "00:30" },
  { label: "00:45", id: "00:45" },
  { label: "01:00", id: "01:00" },
  { label: "01:15", id: "01:15" },
  { label: "01:30", id: "01:30" },
  { label: "01:45", id: "01:45" },
  { label: "02:00", id: "02:00" },
  { label: "02:15", id: "02:15" },
  { label: "02:30", id: "02:30" },
  { label: "02:45", id: "02:45" },
  { label: "03:00", id: "03:00" },
  { label: "03:15", id: "03:15" },
  { label: "03:30", id: "03:30" },
  { label: "03:45", id: "03:45" },
  { label: "04:00", id: "04:00" },
  { label: "04:15", id: "04:15" },
  { label: "04:30", id: "04:30" },
  { label: "04:45", id: "04:45" },
  { label: "05:00", id: "05:00" },
  { label: "05:15", id: "05:15" },
  { label: "05:30", id: "05:30" },
  { label: "05:45", id: "05:45" },
  { label: "06:00", id: "06:00" },
  { label: "06:15", id: "06:15" },
  { label: "06:30", id: "06:30" },
  { label: "06:45", id: "06:45" },
  { label: "07:00", id: "07:00" },
  { label: "07:15", id: "07:15" },
  { label: "07:30", id: "07:30" },
  { label: "07:45", id: "07:45" },
  { label: "08:00", id: "08:00" },
  { label: "08:15", id: "08:15" },
  { label: "08:30", id: "08:30" },
  { label: "08:45", id: "08:45" },
  { label: "09:00", id: "09:00" },
  { label: "09:15", id: "09:15" },
  { label: "09:30", id: "09:30" },
  { label: "09:45", id: "09:45" },
  { label: "10:00", id: "10:00" },
  { label: "10:15", id: "10:15" },
  { label: "10:30", id: "10:30" },
  { label: "10:45", id: "10:45" },
  { label: "11:00", id: "11:00" },
  { label: "11:15", id: "11:15" },
  { label: "11:30", id: "11:30" },
  { label: "11:45", id: "11:45" },
  { label: "12:00", id: "12:00" },
  { label: "12:15", id: "12:15" },
  { label: "12:30", id: "12:30" },
  { label: "12:45", id: "12:45" },
  { label: "13:00", id: "13:00" },
  { label: "13:15", id: "13:15" },
  { label: "13:30", id: "13:30" },
  { label: "13:45", id: "13:45" },
  { label: "14:00", id: "14:00" },
  { label: "14:15", id: "14:15" },
  { label: "14:30", id: "14:30" },
  { label: "14:45", id: "14:45" },
  { label: "15:00", id: "15:00" },
  { label: "15:15", id: "15:15" },
  { label: "15:30", id: "15:30" },
  { label: "15:45", id: "15:45" },
  { label: "16:00", id: "16:00" },
  { label: "16:15", id: "16:15" },
  { label: "16:30", id: "16:30" },
  { label: "16:45", id: "16:45" },
  { label: "17:00", id: "17:00" },
  { label: "17:15", id: "17:15" },
  { label: "17:30", id: "17:30" },
  { label: "17:45", id: "17:45" },
  { label: "18:00", id: "18:00" },
  { label: "18:15", id: "18:15" },
  { label: "18:30", id: "18:30" },
  { label: "18:45", id: "18:45" },
  { label: "19:00", id: "19:00" },
  { label: "19:15", id: "19:15" },
  { label: "19:30", id: "19:30" },
  { label: "19:45", id: "19:45" },
  { label: "20:00", id: "20:00" },
  { label: "20:15", id: "20:15" },
  { label: "20:30", id: "20:30" },
  { label: "20:45", id: "20:45" },
  { label: "21:00", id: "21:00" },
  { label: "21:15", id: "21:15" },
  { label: "21:30", id: "21:30" },
  { label: "21:45", id: "21:45" },
  { label: "22:00", id: "22:00" },
  { label: "22:15", id: "22:15" },
  { label: "22:30", id: "22:30" },
  { label: "22:45", id: "22:45" },
  { label: "23:00", id: "23:00" },
  { label: "23:15", id: "23:15" },
  { label: "23:30", id: "23:30" },
  { label: "23:45", id: "23:45" },
  { label: "23:59", id: "23:59" },
];

export const default_days = [
  { label: "Mon", id: "monday_all_day", key: "monday" },
  { label: "Tues", id: "tuesday_all_day", key: "tuesday" },
  { label: "Wed", id: "wednesday_all_day", key: "wednesday" },
  { label: "Thu", id: "thursday_all_day", key: "thursday" },
  { label: "Fri", id: "friday_all_day", key: "friday" },
  { label: "Sat", id: "saturday_all_day", key: "saturday" },
  { label: "Sun", id: "sunday_all_day", key: "sunday" },
];

export const default_notification_types = [
  { label: "Text", id: "notify_sms" },
  { label: "Phone Call", id: "notify_call_phone" },
  { label: "ethizo Call", id: "notify_call_in_app" },
];
